/**************************************************************************************************************************************************
*   MODULE NAME     :  Help
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  19-04-2021
*   DESCRIPTION     :  Component to load Help page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import axios from "axios";
import './Help.css'

class Help extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Business_SME: "",
            Business_SME_Email: "",
            System_Owner: "",
            System_Owner_Email: "",
            System_Custodian: "",
            System_Custodian_Email: "",
            assignment_group: "",
            admin_email: "",
            support_email: ""
        }
    }

    render() {
        let {
            Business_SME,
            Business_SME_Email,
            System_Owner,
            System_Owner_Email,
            System_Custodian,
            System_Custodian_Email,
            assignment_group,
            admin_email,
            support_email
        } = this.state;
        return <>
            <div className="helpPageWrap">
                <h3>Help Center</h3>
                <br></br>
                <ul>
                    <li>
                        Please call &nbsp;<a href="tel:+1-317-277-7000">Lilly Helpdesk(+1-317-277-7000)</a> &nbsp; to log a
                        ticket for any application issue and inform help desk to
                        assign the ticket to Service Now group GPS-LRLIT-GLB.
                        <br></br>
                    </li>
                    <li>
                        Contact Global Literature Team on mailbox:&nbsp;
                        <a href={`mailto:Global_Literature@lilly.com`}> Global_Literature@lilly.com</a>
                        <br></br>
                    </li>
                    <li>
                    Contact Japan Literature Team on mailbox:&nbsp;
                        <a href={`mailto:JP_QPS_GPSJ_Literature@lilly.com`}> JP_QPS_GPSJ_Literature@lilly.com</a> 
                       <br></br>
                    </li>
                     <li>
                        <a href={`https://lilly-qualitydocs.veevavault.com/ui/#doc_info/2268`} target="_blank">User Manual&nbsp; </a> 
                       <br></br>
                    </li>
                     <li>
                        <a href={`https://lilly-qualitydocs.veevavault.com/ui/#doc_info/358625`} target="_blank">IT Manual&nbsp; </a> 
                       <br></br>
                    </li>
                </ul>
            </div>
        </>
    }
}
export default withRouter(Help);